export default function NotFound() {
    return (
        <div
            style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100vh",
                width: "100vw",
            }}
        >
            <h4>404, Page Not Found</h4>
        </div>
    );
}
